var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-navbar",
    {
      attrs: {
        "menu-items": _vm.menuItems,
        "is-loading": false,
        config: _vm.config,
        company: _vm.company,
        user: _vm.user
      },
      on: {
        toggle: function($event) {
          return _vm.toggleProfile()
        },
        search: function($event) {
          return _vm.toggleSearch()
        },
        logout: function($event) {
          return _vm.logout()
        },
        toggleNotifications: function($event) {
          _vm.toggleNotifications(), _vm.handleAnalytics()
        }
      }
    },
    [
      _c("search-container", {
        staticClass: "search",
        attrs: { "is-opened": _vm.isSearchOpen },
        on: {
          search: function($event) {
            return _vm.toggleSearch()
          },
          close: function($event) {
            _vm.isSearchOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd7d338a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd7d338a","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Layout/LayoutNavbar.vue
// module id = 2126
// module chunks = 1610